import cn from 'classnames';
import * as React from 'react';

import { FavouritesProps } from './types';

const styles = require('./Favourites.css');

export const Favourites: React.FC<FavouritesProps> = props => {
  const { link, count } = props;

  const handleClick = React.useCallback<VoidFunction>(() => {
    // eslint-disable-next-line no-unused-expressions
    window._headerTrackingEvent?.('favorites');
  }, []);

  return (
    <span className="c-header__favourites-mobile-wrap">
      <a onClick={handleClick} href={link} className="c-header__favourites-mobile">
        <span
          className={cn('c-header-active-notification', {
            [styles['display-none']]: !count,
          })}
        />
      </a>
    </span>
  );
};

Favourites.displayName = 'Favourites';
